"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const o=require("@mui/material"),t=require("@mui/material/styles"),r=require("../../assets/icons/ExpandArrow.js");require("react/jsx-runtime");const n=t.styled(o.Typography)(({theme:e})=>({color:e.palette.grey[600],display:"flex",alignItems:"center",justifyContent:"space-between",margin:"8px 0",minHeight:"40px"})),s=t.styled(r.ExpandArrow,{shouldForwardProp:e=>e!=="isExpanded"})`
  ${({isExpanded:e})=>e&&t.css`
      transform: rotate(180deg);
    `}
`,i=t.styled("div")`
  display: flex;
  flex-direction: column;

  ${({open:e})=>e&&t.css`
      height: calc(100% - 144px);
    `}
`,a=t.styled("div")`
  gap: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
`;exports.Container=i;exports.ExpandArrowIcon=s;exports.StyledTypography=n;exports.TodoListContainer=a;
